'use strict';

angular.module('docketbook').controller('acceptConnectionRequestModalController', function (addressBookService, userService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, docketService) {

  $scope.orgs = accessControl.allowedOrganisations()
  $scope.data = {
    selectedOrg: null
  };

  $scope.connection = null;
  $scope.cb = null;
  $scope.loading = false;

  $scope.$parent.showAcceptConnectionModal = function (connection, cb) {
    $scope.cb = cb;
    $scope.connection = connection;
    $scope.loading = false;

    $scope.data.selectedOrg =
      ($scope.orgs.length == 1)
        ? $scope.orgs[0].id
        : null;

    $('#acceptConnectionRequestModal').fadeIn(100);
  }

  $scope.close = function () {
    $('#acceptConnectionRequestModal').fadeOut(100);
    $scope.loading = false
  }

  $scope.accept = function () {
    $scope.loading = true
    userService.getPermissionsForOrg($scope.data.selectedOrg, {}, function (permissions) {
      $scope.connection.invitation.targetId = $scope.data.selectedOrg
      $scope.connection.invitation.status = 'accept'

      if (!permissions.map(p => p.identifier).includes('io.docketbook.uoapi.acceptConnection')) {
        swal({
          title: "Error!",
          text: "You do not have permissions to accept the connection, please contact your organisation administrator.",
          type: "error",
          confirmButtonText: "Ok, got it."
        })
        $scope.loading = false
        return
      }

      userService.saveUserInvitation($scope.connection.invitation, function () {
        $scope.close()
        $scope.cb && $scope.cb()
      }, function () {
        $scope.close()
        swal({
          title: "Error!",
          text: "An error occured while accepting the connection.",
          type: "error",
          confirmButtonText: "Ok, got it."
        })
        $scope.loading = false
      })
    }, function () {
      swal({
        title: "Error!",
        text: "An error occured while accepting the connection.",
        type: "error",
        confirmButtonText: "Ok, got it."
      })
      $scope.loading = false
    })
  }

  $scope.decline = function () {
    swal({
      title: "Are you sure?",
      text: "Do you want to decline this connection request?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, decline it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        $scope.connection.invitation.status = 'decline'
        userService.saveUserInvitation($scope.connection.invitation, function () {
          $scope.close()
          $scope.cb && $scope.cb()
        }, function () {
          swal({
            title: "Error!",
            text: "An error occured while declining the connection.",
            type: "error",
            confirmButtonText: "Ok, got it."
          })
        })
      }
    });

  }
})




// WEBPACK FOOTER //
// ./src/controllers/modals/acceptConnectionRequestModalController.js